import React from 'react'
import { useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import {
  AccessForSelectFragment,
  BulkCreatePerformanceReviewOwnerDocument,
  OwnersSectionFragment,
} from 'generated/resources/graphql'

import { AccessSelector } from 'modules/core/components/AccessSelector'
import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface NewOwnerModalProps {
  onClose: () => void
  owners: OwnersSectionFragment[]
}
const NewOwnerModal = ({ owners, onClose }: NewOwnerModalProps) => {
  const { reviewId } = useParams()

  const [bulkCreatePerformanceReviewOwner, { loading: adding }] = useMutation(
    BulkCreatePerformanceReviewOwnerDocument,
    {
      extractorFn: (data) => data.performanceMutations.bulkCreatePerformanceReviewOwner,
    }
  )

  const handleAddOwner = async () => {
    const response = await bulkCreatePerformanceReviewOwner({
      variables: {
        ownerAccessIds: selectedAccesses.map((item) => item.id),
        reviewProcessId: Number(reviewId),
      },
    })

    const result = handleResult(response, () => undefined)

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }
    onClose()
  }
  const [selectedAccesses, setSelectedAccesses] = React.useState<AccessForSelectFragment[]>([])

  return (
    <Modal
      illustration="user-male-female"
      title={i18n.t('performance_process.reviews.basic_information_section.owners.add_owner')}
      onClose={onClose}
      onSubmit={handleAddOwner}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={adding} submit>
            {i18n.t('performance_process.reviews.basic_information_section.owners.add')}
          </Button>
        </>
      }
    >
      <AccessSelector
        hideBorder
        alwaysOpen
        withAvatar
        width="s400"
        multiple
        value={selectedAccesses}
        onSelect={(value: AccessForSelectFragment[]) => {
          setSelectedAccesses(value)
        }}
        emptyLabel={i18n.t(
          'performance_process.reviews.basic_information_section.owners.empty_results'
        )}
        excludeIds={owners.map((owner) => owner.access?.id).filter(Boolean)}
        withRegularAccess
        terminated={false}
      />
    </Modal>
  )
}

export default NewOwnerModal
